import { Alert, AlertTitle, Box, Link } from '@mui/material';

export default function EventAlert({ title, message, hasLink }) {
  return (
    <Box sx={{ mt: '24px' }}>
      <Alert
        sx={{
          '& .MuiAlert-icon': {
            fontSize: 40,
            color: '#1B8FFF',
          },
        }}
        severity="info"
      >
        <AlertTitle>{title}</AlertTitle>
        {message}{' '}
        {hasLink && (
          <Link
            variant="caption"
            underline="always"
            href="https://www.boletia.com"
          >
            boletia.com
          </Link>
        )}
      </Alert>
    </Box>
  );
}
